import React from 'react';
import { FormattedMessage } from 'react-intl'


export default function trans (id) {
    return <FormattedMessage id={id} />
}